import React from 'react';
import { Heading } from '..';
import css from '../../containers/ListingPage/ListingPage.module.css';

import { FaPhoneAlt, FaEnvelope } from 'react-icons/fa';
import { IoLogoWhatsapp } from "react-icons/io";


const contactMethodDisplayData = {
  phone: {
    name: 'Phone Call',
    icon: <FaPhoneAlt />,
  },
  email: {
    name: 'Email',
    icon: <FaEnvelope />,
  },
  whatsapp: {
    name: 'WhatsApp',
    icon: <IoLogoWhatsapp />,
  },
};

const SectionPreferredContactMethod = props => {
  const { heading, selectedOptions = [] } = props;

  if (!heading || selectedOptions.length === 0) {
    return null;
  }

  return (
    <section className={css.sectionCleaningFacilities}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        {heading}
      </Heading>
      <ul className={css.petTypeList}>
        {selectedOptions.map(option => {
          const method = contactMethodDisplayData[option];
          return (
            <li key={option} className={css.multiEnumItem}>
              <span className={css.facilityIcon}>{method?.icon}</span>
              <span>{method?.name || option}</span>
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default SectionPreferredContactMethod;
